import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import NoticeWrapper from './NoticeWrapper'
import CookiesModalContents from './CookiesModalContents'
import { RpCookiesModal } from 'portal-modules/common/components/modals'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { connect } from 'react-redux'
import Button from 'portal-modules/common/components/Button'
import { RequestContentModal } from 'portal-modules/common/components/modals'
import useCookiesPreferences from 'portal-modules/common/hooks/useCookies'
import usePrivacyPolicies from 'portal-modules/common/hooks/usePrivacyPolicies'
import { SHOW_EMBEDDED_VIEW } from 'portal-modules/common/constants/keys'
import {
  updateCookiesNoticeStatus,
  requestCookieBannerClose,
} from '../redux/modules/cookiesNotice'
import Media from 'react-media'

import {
  StyledCookiesNoticeContainer,
  StyledCookiesNoticeText,
  StyledCookiesNoticeButtonWrapper,
  StyledCookiesNoticePreferences,
  StyledCookiesNoticePrivacyText,
  StyledCookiesNoticePrivacyActionWrapper,
} from './atoms'

const CookiesNotice = ({
  updateCookiesNoticeStatus,
  requestCookieBannerClose,
  groups,
  isCookiesAccepted,
  isGDPR,
}) => {
  const [
    groupState,
    setGroupState,
    handleCookiesUpdate,
    handleCookieBannerClose,
  ] = useCookiesPreferences({
    groups,
    updateCookiesNoticeStatus,
    requestCookieBannerClose,
  })

  const {
    getAllPrivacyPolicies,
    cookieState,
    setCookieState,
  } = usePrivacyPolicies()

  if (sessionStorage.getItem(SHOW_EMBEDDED_VIEW)) {
    isCookiesAccepted = true
  }

  return (
    <Media query='(min-width:769px)'>
      {isLargeScreen => (
        <NoticeWrapper
          onClose={() => handleCookieBannerClose()}
          show={!isCookiesAccepted}
          title={''}
          size={isLargeScreen ? 28 : 20}
        >
          <>
            <StyledCookiesNoticeContainer isLargeScreen={isLargeScreen}>
              <StyledCookiesNoticeText isLargeScreen={isLargeScreen}>
                {__(
                  'We use cookies and services to understand how you use our site and to improve your experience. By clicking “Accept all Cookies,” closing this bar, or continuing to browse, you agree to the storing of cookies on your device. Your cookie settings can be changed at any time by clicking “Cookie Preferences” in the settings of this site. To find out more, please view our',
                )}
                &nbsp;
                <StyledCookiesNoticePrivacyText onClick={getAllPrivacyPolicies}>
                  {__('Privacy Policy')}
                </StyledCookiesNoticePrivacyText>
                .
              </StyledCookiesNoticeText>
              <StyledCookiesNoticePrivacyActionWrapper
                isLargeScreen={isLargeScreen}
              >
                <StyledCookiesNoticeButtonWrapper isLargeScreen={isLargeScreen}>
                  <Button
                    appearance='action'
                    size={isLargeScreen ? 'medium' : 'small'}
                    onClick={() =>
                      handleCookiesUpdate(
                        undefined,
                        isGDPR ? 'reject_all' : 'accept_all',
                      )
                    }
                  >
                    {isGDPR ? __('Deny all Cookies') : __('Accept all Cookies')}
                  </Button>
                </StyledCookiesNoticeButtonWrapper>
                <ModalControl>
                  {({ onClick, ref, ...props }) => (
                    <Fragment>
                      <StyledCookiesNoticePreferences
                        isLargeScreen={isLargeScreen}
                        onClick={onClick}
                        ref={ref}
                      >
                        {__('Manage Preferences')}
                      </StyledCookiesNoticePreferences>
                      {!cookieState.showEntrataPrivacyPolicy ? (
                        <RpCookiesModal
                          {...props}
                          onCancel={props?.onClose}
                          content={
                            <CookiesModalContents
                              onClose={props?.onClose}
                              groupState={groupState}
                              setGroupState={setGroupState}
                              handleCookiesUpdate={handleCookiesUpdate}
                              handlePrivacyPolicies={getAllPrivacyPolicies}
                            />
                          }
                          title={__('Cookie Preferences')}
                          onClose={() =>
                            handleCookiesUpdate(props?.onClose, 'specific')
                          }
                          closeButtonLabel={__('Save Preferences')}
                        />
                      ) : (
                        <RequestContentModal
                          show={cookieState.showEntrataPrivacyPolicy}
                          onClose={() =>
                            setCookieState({
                              ...cookieState,
                              showEntrataPrivacyPolicy: false,
                            })
                          }
                          title={__('Privacy Policy')}
                        >
                          {cookieState.entrataPrivacyPolicy}
                        </RequestContentModal>
                      )}
                    </Fragment>
                  )}
                </ModalControl>
              </StyledCookiesNoticePrivacyActionWrapper>
            </StyledCookiesNoticeContainer>
          </>
        </NoticeWrapper>
      )}
    </Media>
  )
}

CookiesNotice.propTypes = {
  isCookiesAccepted: PropTypes.bool,
  isGDPR: PropTypes.bool,
  updateCookiesNoticeStatus: PropTypes.func,
  onClose: PropTypes.func,
  requestCookieBannerClose: PropTypes.func,
  groups: PropTypes.arrayOf(PropTypes.object),
}

export default connect(
  ({ cookiesNotice }) => ({
    isCookiesAccepted: cookiesNotice?.isCookiesAccepted,
    isGDPR: cookiesNotice?.is_eu,
    groups:
      (cookiesNotice?.groups && Object.values(cookiesNotice?.groups)) || [],
  }),
  { updateCookiesNoticeStatus, requestCookieBannerClose },
)(CookiesNotice)
